export default __webpack_public_path__ + "static/media/building-via-maria.8cab12ce.png";